<template>
  <div class="d-flex flex-column align-center ga-10 ga-sm-20">
    <csm-hero />
    <csm-quote />
    <csm-features />
    <csm-for-who />
    <csm-partners />
    <csm-pricing />
    <csm-recommendations />
    <csm-faq />
  </div>
</template>
